import { useSelector } from 'react-redux';

const useLinkForColumnTypes = ({ columnTypes }) => {
  const links = useSelector((state) => state.resonance.links);

  const groupedLinks = columnTypes.reduce((acc, type) => {
    const linksByType = links.filter(({ audienceHeader }) => type === audienceHeader);
    acc[type] = linksByType;
    return acc;
  }, {});

  const mergedAndFormattedLinks = Object.entries(groupedLinks).map(([type, links]) => ({
    type,
    links,
  }));

  return mergedAndFormattedLinks;
};

export default useLinkForColumnTypes;
